export const capitalizedUserName = (name?: string) => 
  name
    ? name
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
    : "";

export const getColorForUser = (key: string) => {
  const colors = [
    '#FF5733', '#33FF57', '#3357FF', '#FF33A8', '#FF8C33',
    '#33FFF5', '#9D33FF', '#FFD733', '#33FFB8', '#FF3333'
  ];

  const normalizedKey = key.toLowerCase();
  let hash = 0;
  for (let i = 0; i < normalizedKey.length; i++) {
    hash = normalizedKey.charCodeAt(i) + ((hash << 5) - hash);
  }
  return colors[Math.abs(hash) % colors.length];
};


export const formatPrice = (price: string, currency?: string) => {
    if (!price) return "0.00";

    // If no currency provided → return plain number
    if (!currency) return parseFloat(price).toFixed(2);

    return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency,
    }).format(parseFloat(price));
};


export const formatDate = (dateString: string | null) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-GB', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    });
};